<template>
  <l-layout :layout="['xs12']">
    <p class="pl-4 mt-3">有效规则</p>
    <l-pass-rule-list :pass-rules="validRuleList">
      <div @click.stop slot="action" slot-scope="{item, index}">
        <l-option-menu
          v-if="item.ownerType==='object'"
          :options="options"
          @delete="deletePassRule(item)"
          @edit="openSetRuleDialog('edit',item, index)">
          <v-btn icon slot="activator" small>
            <v-icon small>$vuetify.icons.more</v-icon>
          </v-btn>
        </l-option-menu>
      </div>
    </l-pass-rule-list>
    <p class="pl-4 mt-3">失效规则</p>
    <l-pass-rule-list :pass-rules="unuseRuleList">
    </l-pass-rule-list>
    <v-dialog max-width="900px" persistent scrollable v-model="passRuleDialog.activate">
      <set-pass-rule-content
        :authority="authority"
        :params="{index: passRuleDialog.index, type: authority.name}"
        :rule="passRuleDialog.item"
        :status="passRuleDialog.status"
        @cancel="closeSetRuleDialog"
        @save="setPassRule($event.newItem)"
        ref="ruleContent"
        v-if="passRuleDialog.activate"
      >
      </set-pass-rule-content>
    </v-dialog>
    <l-fixed-btn
      @click="openSetRuleDialog('new', null, 0)"
      icon="$vuetify.icons.add"
    ></l-fixed-btn>
  </l-layout>
</template>

<script>
  import LPassRuleList from '../../../components/LPassRuleList'
  import SetPassRuleContent from '../../../components/SetPassRuleContent'
  import LPlatePicker from '../../../components/LPlatePicker'
    export default {
      name: "vehicleRuleDetails",
      components:{
        LPassRuleList,
        SetPassRuleContent,
        LPlatePicker
      },
      props:{
          ruleList:{
            type:Array,
            default:function () {
              return []
            }
          }
      },
      data(){
        return {
          passRuleDialog: {
            activate: false,
            status: 'new',
            item: {},
            index: 0,
          },
          options: [
            {
              event: 'edit',
              icon: '$vuetify.icons.edit',
              label: '编辑'
            },
            {
              event: 'delete',
              icon: '$vuetify.icons.delete',
              label: '删除'
            }
          ],
          validRuleList:[],
          unuseRuleList:[]
        }
      },
      computed:{
        authority(){
          return this.$store.state.reservation.adminAuth
        }
      },
      created(){
        this.dealRuleList()
      },
      methods:{
        dealRuleList(){
          for(let i=0;i<this.ruleList.length;i++){
            if(this.ruleList[i].status+''==='1'){
              this.validRuleList.push(this.ruleList[i])
            }else{
              this.unuseRuleList.push(this.ruleList[i])
            }
          }
        },
        openSetRuleDialog (status, item, index) {
          this.passRuleDialog = {
            activate: true,
            status: status,
            item: item || undefined,
            index: index,
          }
        },
        async setPassRule (rule) {
          rule.groupId = this.$route.query.id
          try {
            await this.$store.dispatch('passControl/setRule', rule)
            this.closeSetRuleDialog()
            this.$L.alert('success', `操作成功`)
            this.$emit('refresh')
          }
          catch (e) {
            this.$L.alert('error', e.message)
          }
        },
        closeSetRuleDialog () {
          this.passRuleDialog = {
            activate: false,
            status: 'new',
            item: undefined,
            index: 0,

          }
        },
        async deletePassRule (rule) {
          let {res, close} = await this.$L.confirm({
            title: '确认删除',
            text: '确认删除该规则？'
          })
          if (res) {
            try {
              await this.$store.dispatch('reservation/deleteRules', [rule])
              this.$L.alert('success', '删除成功')
              this.$emit('refresh')
            }
            catch (e) {
              this.$L.alert('error', e.message)
            }
          }
          close()
        },
      }
    }
</script>

<style scoped>

</style>
